// Centralized Query Keys for Admin Dashboard

export const adminQueryKeys = {
  all: ['admin'] as const,
  
  users: {
    all: ['admin', 'users'] as const,
    lists: () => [...adminQueryKeys.users.all, 'list'] as const,
    list: (orgId?: string) => [...adminQueryKeys.users.lists(), { orgId }] as const,
    details: () => [...adminQueryKeys.users.all, 'detail'] as const,
    detail: (id: number) => [...adminQueryKeys.users.details(), id] as const,
  },

  modelCompare: {
    all: ['admin', 'model-compare'] as const,
    catalog: () => [...adminQueryKeys.modelCompare.all, 'catalog'] as const,
    runs: (page: number) => [...adminQueryKeys.modelCompare.all, 'runs', page] as const,
  },

  aiCalls: {
    all: ['admin', 'ai-calls'] as const,
    summary: (f: object) => [...adminQueryKeys.aiCalls.all, 'summary', f] as const,
    list: (f: object, page: number) => [...adminQueryKeys.aiCalls.all, 'list', f, page] as const,
  },

  sopVideos: {
    all: ['admin', 'sop-videos'] as const,
    lists: () => [...adminQueryKeys.sopVideos.all, 'list'] as const,
    list: (orgId?: string) => [...adminQueryKeys.sopVideos.lists(), { orgId }] as const,
    detail: (id: string) => [...adminQueryKeys.sopVideos.all, 'detail', id] as const,
  },

  integrations: {
    all: ['admin', 'integrations'] as const,
    lists: () => [...adminQueryKeys.integrations.all, 'list'] as const,
    list: (orgId?: string) => [...adminQueryKeys.integrations.lists(), { orgId }] as const,
    details: () => [...adminQueryKeys.integrations.all, 'detail'] as const,
    detail: (orgId: string, id: string) => [...adminQueryKeys.integrations.details(), orgId, id] as const,
    types: () => [...adminQueryKeys.integrations.all, 'types'] as const,
  },

  integrationTypes: {
    all: ['admin', 'integration-types'] as const,
    lists: () => [...adminQueryKeys.integrationTypes.all, 'list'] as const,
    list: () => [...adminQueryKeys.integrationTypes.lists()] as const,
    details: () => [...adminQueryKeys.integrationTypes.all, 'detail'] as const,
    detail: (id: string | number) => [...adminQueryKeys.integrationTypes.details(), id] as const,
  },
  
  dashboard: {
    all: ['admin', 'dashboard'] as const,
    stats: () => [...adminQueryKeys.dashboard.all, 'stats'] as const,
  },

  organizations: {
    all: ['admin', 'organizations'] as const,
    lists: () => [...adminQueryKeys.organizations.all, 'list'] as const,
    details: () => [...adminQueryKeys.organizations.all, 'detail'] as const,
    detail: (id: string) => [...adminQueryKeys.organizations.details(), id] as const,
    members: (orgId: string) => [...adminQueryKeys.organizations.detail(orgId), 'members'] as const,
    integrations: (orgId: string) => [...adminQueryKeys.organizations.detail(orgId), 'integrations'] as const,
  },

  rbac: {
    all: ['admin', 'rbac'] as const,
    roles: () => [...adminQueryKeys.rbac.all, 'roles'] as const,
    features: () => [...adminQueryKeys.rbac.all, 'features'] as const,
    roleFeatures: (roleKey: string) => [...adminQueryKeys.rbac.all, 'role-features', roleKey] as const,
  },

  platformSettings: {
    all: ['admin', 'platform-settings'] as const,
    featureFlags: () => [...adminQueryKeys.platformSettings.all, 'feature-flags'] as const,
    widgetDemoData: () => [...adminQueryKeys.platformSettings.all, 'widget-demo-data'] as const,
  },

  audit: {
    all: ['admin', 'audit'] as const,
    lists: () => [...adminQueryKeys.audit.all, 'list'] as const,
    list: (params: Record<string, unknown>, scope: 'platform' | 'org' = 'platform') =>
      [...adminQueryKeys.audit.lists(), scope, params] as const,
    detail: (id: string) => [...adminQueryKeys.audit.all, 'detail', id] as const,
  },
} as const;
